import { render } from "./map-list.vue?vue&type=template&id=2fbc80ab"
import script from "./map-list.vue?vue&type=script&lang=js"
export * from "./map-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__